















































































































import { Vue, Component, Prop } from "vue-property-decorator";
import mdui from "mdui";
import list from "./list.vue";
import bookCard from "./bookCard.vue";

@Component({
  components: {
    list,
    bookCard,
  },
})
export default class folder extends Vue {
  @Prop() private item: any;
  private url: string = "";
  private title: string = "";
  private isDisable: boolean = false; //防止重复提交
  private addIcon: string =
    "data:image/svg+xml;base64,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";


  public open() {
    var id = "#folder"+this.item.indexId;
    var add = new mdui.Dialog(id); //登录弹出框对象
    add.open();
  }

  public add() {
    // 防止重复提交
    this.isDisable = true;
    var data = JSON.stringify({
      url: this.url,
      title: this.title,
      folderId: this.item.indexId,
    });
    // @ts-ignore
    this.$httpService
      .postData(data, true, "addMarkToFolder", "application/json")
      .then(
        (result: any) => {
          // @ts-ignore
          this.$store.commit("getMarkList");
          // 防止重复提交
          this.isDisable = false;
          this.updateIcon();
        },
        (error: any) => {
          // 防止重复提交
          this.isDisable = false;
        }
      );
  }

  //删除
  public removeUrl(item: any) {
    this.$emit("deleteItem", item.indexId);
    var data = JSON.stringify({
      urlId: item.urlId,
      indexId: item.indexId,
    });
    // @ts-ignore
    this.$httpService
      .postData(data, true, "deleteMark", "application/json")
      .then(
        (result: any) => {
          // @ts-ignore
          this.$store.commit("getMarkList");
        },
        (error: any) => {}
      );
  }
  // 批量删除
  public openRemove() {
    // this.$parent.openRemove()
    this.$emit("openRemove");
  }
  public openMove() {
    this.$emit("setMdMove");
  }
  // 修改标题
  public setTitle(item: any) {
    // 其他参数
    var optione: any = {
      maxlength: 100,
      cancelText: "取消",
      defaultValue: item.title,
    };
    // @ts-ignore
    var http = this.$httpService; //创建对象防止回调函数找不到
    // @ts-ignore
    var store = this.$store;
    mdui.prompt(
      "请输入新的标题",
      function (value) {
        var newTitle = JSON.stringify({
          navigationId: item.indexId,
          title: value,
        });
        // @ts-ignore
        http.postData(newTitle, true, "updateTitle", "application/json").then(
          (result: any) => {
            // @ts-ignore
            store.commit("getMarkList");
          },
          (error: any) => {}
        );
      },
      function () {},
      optione
    );
  }
  get mList(): any {
    return this.item.markList;
  }
  public openMenu(head: any, who: any): void {
    //调用id
    const open: string = head + who;
    let menu: string = "#m" + who; //#whoM
    //参数
    var options: any = {
      position: "top",
      align: "left",
      covered: "false",
      fixed: "true",
    };
    // 判断是否已经有menu打开，因为用的是右键menu不会自动关闭
    if (this.$store.state.menu != null) {
      this.$store.state.menu.close();
    }
    this.$store.commit("setMenu", new mdui.Menu(open, menu, options));
    this.$store.state.menu.open();
  }

  public updateIcon() {
    // @ts-ignore
    var store = this.$store;
    let i = 0;
    var myVar = setInterval(function () {
      //TODO 知识总结
      // @ts-ignore
      const list: any = JSON.parse(localStorage.getItem("markList"));
      i++;
      if (list[list.length - 1].icon || i == 10) {
        // 退出轮询
        clearInterval(myVar);
      }
      // 关闭消息提示
      store.commit("setMsFlag", false);
      store.commit("getMarkList"); //TODO 不要提示更新成功这几个字
    }, 3000);
  }
}
